import { ISettings } from 'types';
import { axiosInstanceWithToken } from 'utils/axios';

export const fetchSettings = async () => axiosInstanceWithToken().get<ISettings>('settings');

export const updateSettings = async (data: FormData) => axiosInstanceWithToken().post<ISettings>('settings', data);
